module.exports = __webpack_public_path__ + "img/arrow_down.689c7c2b.svg";